import { useEffect, useState } from "react"
import { SignUpSelectFieldProps } from "./SignUpSelectField"
import { Menu, Button } from "@mantine/core"
import { ChevronDown } from "lucide-react"

export interface SubmitOnSelectSelectFieldProps extends SignUpSelectFieldProps {
	handleSubmitOnSelect: (option: string) => Promise<void>
	field: string
}

export function SubmitOnSelectSelectField({ handleSubmitOnSelect, ...props }: SubmitOnSelectSelectFieldProps) {
	const {
		fieldName,
		updateField,
		options,
		label,
		required,
		placeholder,
		field,
		selectedItemStyle,
		size = "full-width",
		labelPosition = "top",
	} = props

	const [opened, setOpened] = useState(false)
	const [selectedOption, setSelectedOption] = useState({ changed: false, option: placeholder })

	const handleToggle = () => {
		setOpened(!opened)
	}

	const handleClose = () => {
		setOpened(false)
	}

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === " " || e.key === "Enter") {
			e.preventDefault()
			handleToggle()
		}
	}

	const handleSelect = (option: string, optionLabel: string | undefined = undefined) => {
		if (optionLabel) {
			setSelectedOption({ changed: true, option: optionLabel })
		} else {
			setSelectedOption({ changed: true, option: option })
		}
		updateField({ [fieldName]: option })
		handleClose()
	}

	useEffect(() => {
		if (selectedOption.changed) {
			handleSubmitOnSelect(fieldName)
		}
	}, [selectedOption])

	return (
		<div className={`sign-up-select sign-up-select-label-position-${labelPosition}`}>
			<label className="bs-label">
				{label} {required && <span style={{ color: "var(--ara-red" }}>{" *"}</span>}
			</label>
			<div className={`sign-up-select-${size}`}>
				<Menu opened={opened} onClose={handleClose} position="bottom-start" withinPortal={false}>
					<Menu.Target>
						<Button
							className="sign-up-select-toggle"
							onClick={handleToggle}
							onKeyDown={handleKeyDown}
							variant="default"
							rightSection={<ChevronDown size={16} />}>
							<span style={selectedItemStyle}>
								{typeof selectedOption.option === "string" ? selectedOption.option : String(selectedOption.option)}
							</span>
						</Button>
					</Menu.Target>
					<Menu.Dropdown className="sign-up-select-menu">
						{options.map((option) => {
							if (option.text) {
								return (
									<Menu.Item onClick={() => handleSelect(option.key, option.label)} key={option.key}>
										{option.text}
									</Menu.Item>
								)
							} else {
								return (
									<Menu.Item onClick={() => handleSelect(option)} key={option}>
										{option}
									</Menu.Item>
								)
							}
						})}
					</Menu.Dropdown>
				</Menu>
			</div>
		</div>
	)
}
